import { briefingApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteBrief() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        return briefingApi.delete(`briefs/${code}`).json();
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefs'] }),
  });
}
